module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ProgressCircle__wrapper",
    attrs: {
      "data-progress": _vm.progress
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__overlay"
  }, [_vm._v("\n    " + _vm._s(_vm.progress) + "%\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ProgressCircle__circle"
  }, [_c('div', {
    staticClass: "ProgressCircle__slice full"
  }, [_c('div', {
    staticClass: "ProgressCircle__fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__slice"
  }, [_c('div', {
    staticClass: "ProgressCircle__fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "ProgressCircle__fill ProgressCircle__bar"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3668bf47","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/progress-circle/progress-circle.vue
// module id = 438
// module chunks = 1